import Launch from '@/pages/debug/Launch'
import NotFound from '@/pages/common/NotFound'

import Org from '@/pages/common/Org'
import published from '@/pages/published/routes'
import login from '@/pages/login/routes'
import forget from '@/pages/forget/routes'
import register from '@/pages/register/routes'
import my from '@/pages/my/routes'
import book from '@/pages/book/routes'

export default [
  {
    path: '/',
    name: 'debug-launch',
    component: Launch
  },
  {
    path: '/errors/404',
    name: 'not-found',
    component: NotFound
  },

  {
    path: '/:orgcode',
    component: Org,
    children: [
      ...published,
      ...login,
      ...forget,
      ...register,
      ...my,
      ...book
    ]
  },

  {
    path: '*',
    component: NotFound
  }
]
